(function () {
  'use strict';

  var SECTION_SELECTOR = '.acc-hero[data-section-id]';
  var initedSections = new WeakSet();

  function initAccordionHeroSection(section) {
    try {
      if (!section || initedSections.has(section)) return;
      var cards = Array.prototype.slice.call(section.querySelectorAll('.acc-card'));
      if (!cards.length) return;
      initedSections.add(section);

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });
        cards.forEach(function (card) { observer.observe(card); });
      } else {
        cards.forEach(function (c) { c.classList.add('is-visible'); });
      }

      var supportsHover = false;
      try {
        supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      } catch (mqErr) {
        supportsHover = false;
      }

      if (supportsHover) {
        cards.forEach(function (card) {
          var img = card.querySelector('.acc-card__img');
          if (!img) return;
          card.addEventListener('mousemove', function (e) {
            var r = card.getBoundingClientRect();
            var xp = (e.clientX - r.left) / r.width  - 0.5;
            var yp = (e.clientY - r.top)  / r.height - 0.5;
            img.style.transform =
              'scale(1.08) translate(' + (xp * -10) + 'px,' + (yp * -10) + 'px)';
          });
          card.addEventListener('mouseleave', function () {
            img.style.transform = '';
          });
        });
      }
    } catch (err) {
      if (window.Shopify && window.Shopify.designMode) {
        console.warn('accordion-hero: skipped a section due to an error', err);
      }
    }
  }

  function initAllAccordionHeroes() {
    try {
      var sections = document.querySelectorAll(SECTION_SELECTOR);
      Array.prototype.forEach.call(sections, initAccordionHeroSection);
    } catch (err) {
      if (window.Shopify && window.Shopify.designMode) {
        console.warn('accordion-hero: init failed', err);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAccordionHeroes);
  } else {
    initAllAccordionHeroes();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.detail) return;
      var section = document.querySelector(
        '.acc-hero[data-section-id="' + e.detail.sectionId + '"]'
      );
      if (!section) return;
      initedSections.delete(section);
      initAccordionHeroSection(section);
    });
  }
}());